import { z } from "zod";

export const adminNoteSchema = z.object({
  text: z.string().nonempty("Required"),
});
